import { render } from "./ProductInCheckoutCard.vue?vue&type=template&id=12312fd4&scoped=true"
import script from "./ProductInCheckoutCard.vue?vue&type=script&lang=js"
export * from "./ProductInCheckoutCard.vue?vue&type=script&lang=js"

import "./ProductInCheckoutCard.vue?vue&type=style&index=0&id=12312fd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12312fd4"]])

export default __exports__